import '../../ApplicantInfo/applicant-info.scss';
import {useIntl} from "react-intl";
import {Modal} from "react-bootstrap";

interface ReConfirmInfo{
    show: boolean;
    onHide: () => void;
    onConfirm?: () => void;
}

export function ModalReConfirm(props:ReConfirmInfo){
    const intl = useIntl();
    const {show, onHide, onConfirm} = props;
    const AceptInfo = (e: React.FormEvent) => {
        e.preventDefault();
        onConfirm?.();
        onHide();
    };
    return (
  <Modal show={show} onHide={onHide}>
    <form onSubmit={AceptInfo}>
      <Modal.Header>
        <Modal.Title>
          <div className="title-reConfirmInfo" >
            {'VERIFIQUE SU INFORMACIÓN SEA CORRECTA PARA CONTINUAR'}
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col">
            <div className={"form-know-you-item-button"} onClick={onHide}>
              {intl.formatMessage({ id: "button_cancel" })}
            </div>
          </div>
          <div className="col"></div>
          <div className="col">
            <button type="submit" className={"form-know-you-item-button-gray"}>
              {intl.formatMessage({ id: "button_continue" })}
            </button>
          </div>
        </div>
      </Modal.Body>
    </form>
  </Modal>
);

}
